// extracted by mini-css-extract-plugin
export default {"paddingVertical":"Tooltips_paddingVertical_D686b","premiumRow":"Tooltips_premiumRow_m6mCM","padding":"Tooltips_padding_tcfWa","paddingHorisontal":"Tooltips_paddingHorisontal_Nbbmf"};